import { DatePicker, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";

import { WORKFLOW_STATUS_OPTIONS } from "../../constants/automation.constants";

const { RangePicker } = DatePicker;

interface AutomationListFiltersProps {
  statusFilter: string | null;
  startDate: string | null;
  endDate: string | null;
  activeFiltersCount: number;
  onStatusChange: (value: string | null) => void;
  onDateChange: (start: string | null, end: string | null) => void;
  onReset: () => void;
}

const AutomationListFilters: React.FC<AutomationListFiltersProps> = ({
  statusFilter,
  startDate,
  endDate,
  activeFiltersCount,
  onStatusChange,
  onDateChange,
  onReset,
}) => {
  const handleRangeChange = (range: [Dayjs | null, Dayjs | null] | null) => {
    const [start, end] = range || [null, null];
    onDateChange(
      start ? start.format("YYYY-MM-DD") : null,
      end ? end.format("YYYY-MM-DD") : null,
    );
  };

  const rangeValue: [Dayjs | null, Dayjs | null] = [
    startDate ? dayjs(startDate) : null,
    endDate ? dayjs(endDate) : null,
  ];

  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div>
            <h4 className="mb-1 d-flex align-items-center">
              <i className="ti ti-bolt text-info me-2" style={{ fontSize: 20 }} />
              Automation List
            </h4>
            <p className="text-muted mb-0">
              Manage and monitor your automated workflows
            </p>
          </div>
        </div>
      </div>

      <div className="card-header d-flex align-items-center justify-content-end flex-wrap row-gap-2">
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-2">
          <div className="me-2 mb-2">
            <Select
              style={{ width: 160, minHeight: 38 }}
              placeholder="Status"
              value={statusFilter ?? undefined}
              allowClear
              onChange={(value) => onStatusChange((value as string) ?? null)}
              options={WORKFLOW_STATUS_OPTIONS}
            />
          </div>
          <div className="me-2">
            <RangePicker
              value={rangeValue}
              onChange={handleRangeChange}
              format="DD MMM YYYY"
              style={{ minHeight: 38 }}
              allowClear
            />
          </div>
          <div className="mb-2">
            <button
              type="button"
              className={`btn btn-md ${activeFiltersCount > 0 ? "btn-warning" : "btn-outline-danger"} position-relative py-2`}
              onClick={onReset}
              disabled={activeFiltersCount === 0}
            >
              <i className="ti ti-refresh me-1" />
              Reset
              {activeFiltersCount > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "10px" }}
                >
                  {activeFiltersCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomationListFilters;
